import { lazy,Route } from '@tanstack/router'

import type { RegisterSearch } from './register'
import { rootRoute } from './root'

const TJRegister = lazy(() => import('../pages/tj-register'))

export const tjRegisterRoute = new Route({
  getParentRoute: () => rootRoute,
  path: '/tj-register',
  component: TJRegister,
  validateSearch: (search: Record<string, unknown>): RegisterSearch => {
    return search
  },
})
